module.exports = __webpack_public_path__ + "img/abibaro_logo.afa49b51.svg";